module.exports = __webpack_public_path__ + "img/surveillance.9a7af88c.jpg";